import { createRoute, AnyRoute } from '@tanstack/react-router';
import { LessonDetailPage } from '@new/features/lessons/pages/LessonDetailPage';
import { ObjectiveDetailPage } from '@new/features/objectives/pages/ObjectiveDetailPage';
import LessonEdit from '@screens/lessons/LessonEdit';

export function createLessonRoutes(parent: AnyRoute) {
  const singleLessonRoute = createRoute({
    getParentRoute: () => parent,
    path: 'lessons/$lessonId',
    component: LessonDetailPage,
  });

  const objectiveRoute = createRoute({
    getParentRoute: () => parent,
    path: 'lessons/$lessonId/objectives/$objectiveId',
    component: ObjectiveDetailPage,
  });

  const lessonEditRoute = createRoute({
    getParentRoute: () => parent,
    path: 'lessons/$lessonId/edit',
    component: LessonEdit,
  });

  return [singleLessonRoute, objectiveRoute, lessonEditRoute];
}
